import { STATIC_URL } from '../config';

export function getLogoUrl(company: any) {
  return `${STATIC_URL}/companies/${company.id}/logos/${company.logo}`;
}
